const hasCustomFields = (widgetFields, defaultFields) => widgetFields.subtract(["message", "timestamp"]).filter((field) => !defaultFields.find((lakeField) => lakeField.name === field)).size >= 1;
export default hasCustomFields;
